import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const t = {
  es: {
    nav: {
      home: "Inicio",
      motos: "Motos",
      packages: "Paquetes",
      rates: "Precios",
      gallery: "Galería",
      about: "Nosotros",
      contact: "Contacto",
      book: "Reservar",
    },
    hero: {
      tag: "San Juan del Sur, Nicaragua",
      title1: "Rueda libre en",
      title2: "San Juan del Sur.",
      subtitle:
        "Alquiler de motos Honda Navi 110cc y Genesis SX1 150cc. Autenticidad, aventura y libertad al mejor precio.",
      cta: "Reservar por WhatsApp",
      ctaAlt: "Ver motos",
    },
    about: {
      kicker: "Sobre nosotros",
      title: "Motos limpias. Precios justos. Aventuras reales.",
      body:
        "En Jhossy Motos Rental SJDS nos dedicamos a brindar un servicio de alquiler de motocicletas seguro, confiable y accesible, ofreciendo motos en excelentes condiciones y una atención personalizada que garantice la satisfacción de nuestros clientes. Nuestro compromiso es facilitar la movilidad de residentes y turistas, contribuyendo a que cada viaje sea una experiencia cómoda, práctica y memorable, con responsabilidad, honestidad y calidad en cada servicio.",
      f1: "Atención en 4 idiomas",
      f2: "Cascos incluidos",
      f3: "Servicio de entrega",
      f4: "Alquiler corto y largo plazo",
    },
    moto: {
      kicker: "Nuestra flota",
      title: "Elige tu moto",
      subtitle:
        "Todas nuestras motos son Honda, revisadas antes de cada alquiler.",
      navi: {
        name: "Honda Navi",
        engine: "110cc · Automática",
        desc: "Perfecta para la ciudad y las playas cercanas. Ligera, ágil, fácil de manejar incluso si nunca has montado.",
      },
      sx2: {
        name: "Genesis SX1",
        engine: "150cc · Manual",
        desc: "Dual-sport para exploradores. Ideal para caminos de tierra, cerros y playas escondidas.",
      },
      day: "por día",
      week: "por semana",
      month: "por mes",
      book: "Reservar esta moto",
    },
    rates: {
      kicker: "Tarifas",
      title: "Precios claros, sin sorpresas",
      subtitle: "Precios en USD. Cascos y servicio de entrega incluidos.",
      day: "Día",
      week: "Semana",
      month: "Mes",
    },
    packages: {
      kicker: "Paquetes",
      title: "Ahorra con nuestros paquetes",
      subtitle:
        "Perfectos para familias, parejas y grupos de amigos. Todas las motos son Honda Navi 110cc.",
      bikes: "motos",
      days: "días",
      price: "Precio del paquete",
      book: "Reservar paquete",
      popular: "Más popular",
      includes: {
        title: "Incluye",
        bikes: "{{n}} motocicletas Honda Navi",
        helmets: "Cascos de seguridad para cada conductor",
        assist: "Asistencia básica durante todo el período de alquiler",
      },
      duo: {
        badge: "Paquete Dúo",
        for: "Ideal para parejas, amigos o viajeros que desean recorrer la zona con total libertad y al mejor precio.",
      },
      trio: {
        badge: "Paquete Grupal",
        for: "Ideal para grupos de amigos o familias que buscan una opción práctica, cómoda y con excelente relación calidad-precio.",
      },
      quad: {
        badge: "Paquete Grupal",
        for: "Ideal para familias, grupos de amigos o recorridos turísticos que desean una experiencia cómoda y económica.",
      },
    },
    gallery: {
      kicker: "Galería",
      title: "Clientes felices",
      subtitle: "Historias reales de riders en San Juan del Sur.",
    },
    location: {
      kicker: "Ubicación",
      title: "Encuéntranos en el centro",
      body: "Estamos en el corazón de San Juan del Sur, a pasos de la playa. Ven a saludar o escríbenos por WhatsApp.",
      hours: "Lunes a Domingo · 8:30 a. m. – 5:00 p. m.",
      hoursSubtitle:
        "En Jhossy Motos Rental estamos listos para atenderte y ayudarte a encontrar la motocicleta ideal para tu próxima aventura.",
      directions: "Cómo llegar",
    },
    contact: {
      kicker: "Contacto",
      title: "¿Listo para rodar?",
      body: "Escríbenos por WhatsApp para reservar tu moto ahora mismo.",
      cta: "Chatear por WhatsApp",
      emailCta: "Enviar correo",
      emailTitle: "Envíanos un correo",
      emailSubtitle: "Cuéntanos qué necesitas y te respondemos rápido.",
      emailPlaceholderName: "Tu nombre",
      emailPlaceholderMessage: "Fechas, moto que te interesa, dudas…",
      emailSend: "Abrir correo",
      emailOr: "o",
    },
    payments: {
      kicker: "Métodos de pago",
      title: "Paga rápido, fácil y seguro",
      body:
        "En Jhossy Motos Rental queremos hacer tu experiencia más cómoda. Aceptamos pagos con POS, para que puedas pagar con tu tarjeta de débito o crédito de forma rápida, fácil y segura.",
      tag: "Aceptamos POS",
      cards: "Débito · Crédito",
      footerLabel: "Pagos: POS · Débito · Crédito",
    },
    footer: {
      tagline: "Alquiler de motos en San Juan del Sur, Nicaragua.",
      rights: "Todos los derechos reservados.",
    },
    common: {
      scrollTop: "Subir",
      whatsapp: "WhatsApp",
      callNow: "Llamar ahora",
    },
  },
  en: {
    nav: { home: "Home", motos: "Bikes", packages: "Packages", rates: "Rates", gallery: "Gallery", about: "About", contact: "Contact", book: "Book" },
    hero: {
      tag: "San Juan del Sur, Nicaragua",
      title1: "Ride free in",
      title2: "San Juan del Sur.",
      subtitle:
        "Honda Navi 110cc and Genesis SX1 150cc motorcycle rentals. Authentic adventure, honest prices.",
      cta: "Book via WhatsApp",
      ctaAlt: "See bikes",
    },
    about: {
      kicker: "About us",
      title: "Clean bikes. Fair prices. Real adventures.",
      body:
        "At Jhossy Motos Rental SJDS we are committed to providing a safe, reliable and affordable motorcycle rental service — with bikes in excellent condition and personalized attention that guarantees our customers' satisfaction. Our mission is to make mobility easier for locals and tourists, turning every ride into a comfortable, practical and memorable experience, with responsibility, honesty and quality in every service.",
      f1: "Multilingual service",
      f2: "Helmets included",
      f3: "Delivery service",
      f4: "Short & long-term rental",
    },
    moto: {
      kicker: "Our fleet",
      title: "Pick your bike",
      subtitle: "All Honda, all serviced before every rental.",
      navi: {
        name: "Honda Navi",
        engine: "110cc · Automatic",
        desc: "Perfect for the town and nearby beaches. Light, nimble, easy to ride even if you're new.",
      },
      sx2: {
        name: "Genesis SX1",
        engine: "150cc · Manual",
        desc: "Dual-sport for explorers. Great for dirt roads, hills and hidden beaches.",
      },
      day: "per day",
      week: "per week",
      month: "per month",
      book: "Book this bike",
    },
    rates: {
      kicker: "Rates",
      title: "Clear prices. No surprises.",
      subtitle: "Prices in USD. Helmets and delivery included.",
      day: "Day",
      week: "Week",
      month: "Month",
    },
    packages: {
      kicker: "Packages",
      title: "Save with our bundles",
      subtitle:
        "Perfect for families, couples and groups of friends. All bikes are Honda Navi 110cc.",
      bikes: "bikes",
      days: "days",
      price: "Package price",
      book: "Book package",
      popular: "Most popular",
      includes: {
        title: "Included",
        bikes: "{{n}} Honda Navi motorcycles",
        helmets: "Safety helmet for every rider",
        assist: "Basic assistance during the whole rental period",
      },
      duo: {
        badge: "Duo Package",
        for: "Ideal for couples, friends or travellers who want to explore the area freely at the best price.",
      },
      trio: {
        badge: "Group Package",
        for: "Ideal for groups of friends or families looking for a practical, comfortable and great-value option.",
      },
      quad: {
        badge: "Group Package",
        for: "Ideal for families, groups of friends or tourist rides who want a comfortable and affordable experience.",
      },
    },
    gallery: { kicker: "Gallery", title: "Happy customers", subtitle: "Real stories from riders in San Juan del Sur." },
    location: {
      kicker: "Location",
      title: "Find us downtown",
      body: "We are in the heart of San Juan del Sur, steps from the beach. Come say hi or reach us on WhatsApp.",
      hours: "Monday to Sunday · 8:30 AM – 5:00 PM",
      hoursSubtitle:
        "At Jhossy Motos Rental we're ready to help you find the perfect motorcycle for your next adventure.",
      directions: "Directions",
    },
    contact: {
      kicker: "Contact",
      title: "Ready to ride?",
      body: "Reach out on WhatsApp to book your bike right now.",
      cta: "Chat on WhatsApp",
      emailCta: "Send email",
      emailTitle: "Send us an email",
      emailSubtitle: "Tell us what you need and we'll get back to you fast.",
      emailPlaceholderName: "Your name",
      emailPlaceholderMessage: "Dates, bike you want, questions…",
      emailSend: "Open email",
      emailOr: "or",
    },
    payments: {
      kicker: "Payment methods",
      title: "Pay fast, easy and safe",
      body:
        "At Jhossy Motos Rental we want to make your experience easier. We accept POS payments so you can pay with your debit or credit card quickly, easily and securely.",
      tag: "We accept POS",
      cards: "Debit · Credit",
      footerLabel: "Payments: POS · Debit · Credit",
    },
    footer: { tagline: "Motorcycle rentals in San Juan del Sur, Nicaragua.", rights: "All rights reserved." },
    common: { scrollTop: "Top", whatsapp: "WhatsApp", callNow: "Call now" },
  },
  fr: {
    nav: { home: "Accueil", motos: "Motos", packages: "Forfaits", rates: "Tarifs", gallery: "Galerie", about: "À propos", contact: "Contact", book: "Réserver" },
    hero: {
      tag: "San Juan del Sur, Nicaragua",
      title1: "Roulez libre à",
      title2: "San Juan del Sur.",
      subtitle:
        "Location de motos Honda Navi 110cc et Genesis SX1 150cc. Aventure authentique, prix honnêtes.",
      cta: "Réserver via WhatsApp",
      ctaAlt: "Voir les motos",
    },
    about: {
      kicker: "À propos",
      title: "Motos propres. Prix justes. Vraies aventures.",
      body:
        "Chez Jhossy Motos Rental SJDS, nous nous engageons à offrir un service de location de motos sûr, fiable et accessible — avec des motos en excellent état et une attention personnalisée qui garantit la satisfaction de nos clients. Notre mission est de faciliter la mobilité des résidents et des touristes, faisant de chaque trajet une expérience confortable, pratique et mémorable, avec responsabilité, honnêteté et qualité à chaque service.",
      f1: "Service multilingue",
      f2: "Casques inclus",
      f3: "Service de livraison",
      f4: "Location courte et longue durée",
    },
    moto: {
      kicker: "Notre flotte",
      title: "Choisissez votre moto",
      subtitle: "Toutes Honda, révisées avant chaque location.",
      navi: {
        name: "Honda Navi",
        engine: "110cc · Automatique",
        desc: "Parfaite pour la ville et les plages proches. Légère, agile, facile même pour débutants.",
      },
      sx2: {
        name: "Genesis SX1",
        engine: "150cc · Manuelle",
        desc: "Dual-sport pour explorateurs. Idéale pour pistes, collines et plages secrètes.",
      },
      day: "par jour",
      week: "par semaine",
      month: "par mois",
      book: "Réserver cette moto",
    },
    rates: { kicker: "Tarifs", title: "Prix clairs. Sans surprises.", subtitle: "Prix en USD. Casques et livraison inclus.", day: "Jour", week: "Semaine", month: "Mois" },
    packages: {
      kicker: "Forfaits",
      title: "Économisez avec nos forfaits",
      subtitle:
        "Parfait pour familles, couples et groupes d'amis. Toutes les motos sont des Honda Navi 110cc.",
      bikes: "motos",
      days: "jours",
      price: "Prix du forfait",
      book: "Réserver le forfait",
      popular: "Le plus populaire",
      includes: {
        title: "Inclus",
        bikes: "{{n}} motos Honda Navi",
        helmets: "Casque de sécurité pour chaque conducteur",
        assist: "Assistance de base pendant toute la location",
      },
      duo: {
        badge: "Forfait Duo",
        for: "Idéal pour couples, amis ou voyageurs souhaitant explorer la région librement au meilleur prix.",
      },
      trio: {
        badge: "Forfait Groupe",
        for: "Idéal pour groupes d'amis ou familles cherchant une option pratique, confortable et à excellent rapport qualité-prix.",
      },
      quad: {
        badge: "Forfait Groupe",
        for: "Idéal pour familles, groupes d'amis ou balades touristiques recherchant une expérience confortable et économique.",
      },
    },
    gallery: { kicker: "Galerie", title: "Clients heureux", subtitle: "Histoires réelles de riders à San Juan del Sur." },
    location: { kicker: "Adresse", title: "Trouvez-nous au centre", body: "Au cœur de San Juan del Sur, à deux pas de la plage. Venez nous saluer ou écrivez-nous sur WhatsApp.", hours: "Lundi au dimanche · 8h30 – 17h00", hoursSubtitle: "Chez Jhossy Motos Rental, nous sommes prêts à vous aider à trouver la moto idéale pour votre prochaine aventure.", directions: "Itinéraire" },
    contact: { kicker: "Contact", title: "Prêt à rouler ?", body: "Contactez-nous sur WhatsApp pour réserver maintenant.", cta: "Chatter sur WhatsApp", emailCta: "Envoyer un e-mail", emailTitle: "Envoyez-nous un e-mail", emailSubtitle: "Dites-nous ce dont vous avez besoin, nous répondons vite.", emailPlaceholderName: "Votre nom", emailPlaceholderMessage: "Dates, moto souhaitée, questions…", emailSend: "Ouvrir l'e-mail", emailOr: "ou" },
    payments: {
      kicker: "Moyens de paiement",
      title: "Payez rapidement, facilement et en sécurité",
      body:
        "Chez Jhossy Motos Rental, nous voulons rendre votre expérience plus agréable. Nous acceptons les paiements par POS pour que vous puissiez payer par carte de débit ou de crédit rapidement, facilement et en toute sécurité.",
      tag: "Nous acceptons POS",
      cards: "Débit · Crédit",
      footerLabel: "Paiement : POS · Débit · Crédit",
    },
    footer: { tagline: "Location de motos à San Juan del Sur, Nicaragua.", rights: "Tous droits réservés." },
    common: { scrollTop: "Haut", whatsapp: "WhatsApp", callNow: "Appeler" },
  },
  de: {
    nav: { home: "Start", motos: "Motorräder", packages: "Pakete", rates: "Preise", gallery: "Galerie", about: "Über uns", contact: "Kontakt", book: "Buchen" },
    hero: {
      tag: "San Juan del Sur, Nicaragua",
      title1: "Frei fahren in",
      title2: "San Juan del Sur.",
      subtitle:
        "Motorradverleih Honda Navi 110ccm und Genesis SX1 150ccm. Authentisches Abenteuer, faire Preise.",
      cta: "Über WhatsApp buchen",
      ctaAlt: "Motorräder ansehen",
    },
    about: {
      kicker: "Über uns",
      title: "Saubere Motorräder. Faire Preise. Echte Abenteuer.",
      body:
        "Bei Jhossy Motos Rental SJDS bieten wir einen sicheren, zuverlässigen und erschwinglichen Motorradverleih — mit Motorrädern in hervorragendem Zustand und persönlicher Betreuung, die die Zufriedenheit unserer Kunden garantiert. Unser Anspruch ist es, die Mobilität von Einheimischen und Touristen zu erleichtern, damit jede Fahrt zu einem bequemen, praktischen und unvergesslichen Erlebnis wird – mit Verantwortung, Ehrlichkeit und Qualität in jedem Service.",
      f1: "Mehrsprachiger Service",
      f2: "Helme inklusive",
      f3: "Lieferservice",
      f4: "Kurz- und Langzeitmiete",
    },
    moto: {
      kicker: "Unsere Flotte",
      title: "Wähle dein Bike",
      subtitle: "Alle Honda, vor jeder Vermietung gewartet.",
      navi: { name: "Honda Navi", engine: "110ccm · Automatik", desc: "Perfekt für Stadt und nahe Strände. Leicht und einfach zu fahren, auch für Anfänger." },
      sx2: { name: "Genesis SX1", engine: "150ccm · Schaltgetriebe", desc: "Dual-Sport für Entdecker. Ideal für Schotter, Hügel und versteckte Strände." },
      day: "pro Tag",
      week: "pro Woche",
      month: "pro Monat",
      book: "Dieses Bike buchen",
    },
    rates: { kicker: "Preise", title: "Klare Preise. Keine Überraschungen.", subtitle: "Preise in USD. Helme & Lieferung inklusive.", day: "Tag", week: "Woche", month: "Monat" },
    packages: {
      kicker: "Pakete",
      title: "Spar mit unseren Paketen",
      subtitle:
        "Perfekt für Familien, Paare und Freundesgruppen. Alle Motorräder sind Honda Navi 110ccm.",
      bikes: "Bikes",
      days: "Tage",
      price: "Paketpreis",
      book: "Paket buchen",
      popular: "Am beliebtesten",
      includes: {
        title: "Enthalten",
        bikes: "{{n}} Honda Navi Motorräder",
        helmets: "Sicherheitshelm für jeden Fahrer",
        assist: "Basis-Assistenz während der gesamten Mietdauer",
      },
      duo: {
        badge: "Duo-Paket",
        for: "Ideal für Paare, Freunde oder Reisende, die die Gegend frei und zum besten Preis erkunden möchten.",
      },
      trio: {
        badge: "Gruppen-Paket",
        for: "Ideal für Freundesgruppen oder Familien, die eine praktische, bequeme und preiswerte Option suchen.",
      },
      quad: {
        badge: "Gruppen-Paket",
        for: "Ideal für Familien, Freundesgruppen oder Touristenausflüge — bequem und günstig.",
      },
    },
    gallery: { kicker: "Galerie", title: "Zufriedene Kunden", subtitle: "Echte Geschichten von Fahrern in San Juan del Sur." },
    location: { kicker: "Standort", title: "Uns im Zentrum finden", body: "Im Herzen von San Juan del Sur, wenige Schritte vom Strand. Komm vorbei oder schreib uns auf WhatsApp.", hours: "Montag bis Sonntag · 8:30 – 17:00 Uhr", hoursSubtitle: "Bei Jhossy Motos Rental helfen wir dir gerne, das perfekte Motorrad für dein nächstes Abenteuer zu finden.", directions: "Route" },
    contact: { kicker: "Kontakt", title: "Bereit zu fahren?", body: "Schreib uns auf WhatsApp, um jetzt zu buchen.", cta: "Auf WhatsApp chatten", emailCta: "E-Mail senden", emailTitle: "Schreib uns eine E-Mail", emailSubtitle: "Sag uns, was du brauchst — wir antworten schnell.", emailPlaceholderName: "Dein Name", emailPlaceholderMessage: "Termine, gewünschtes Bike, Fragen…", emailSend: "E-Mail öffnen", emailOr: "oder" },
    payments: {
      kicker: "Zahlungsmethoden",
      title: "Schnell, einfach und sicher zahlen",
      body:
        "Bei Jhossy Motos Rental möchten wir Ihr Erlebnis angenehmer machen. Wir akzeptieren POS-Zahlungen, damit Sie mit Debit- oder Kreditkarte schnell, einfach und sicher zahlen können.",
      tag: "Wir akzeptieren POS",
      cards: "Debit · Kredit",
      footerLabel: "Zahlung: POS · Debit · Kredit",
    },
    footer: { tagline: "Motorradverleih in San Juan del Sur, Nicaragua.", rights: "Alle Rechte vorbehalten." },
    common: { scrollTop: "Oben", whatsapp: "WhatsApp", callNow: "Anrufen" },
  },
  ru: {
    nav: { home: "Главная", motos: "Мотоциклы", packages: "Пакеты", rates: "Цены", gallery: "Галерея", about: "О нас", contact: "Контакты", book: "Забронировать" },
    hero: {
      tag: "Сан-Хуан-дель-Сур, Никарагуа",
      title1: "Свобода на дороге в",
      title2: "Сан-Хуан-дель-Сур.",
      subtitle:
        "Аренда мотоциклов Honda Navi 110cc и Genesis SX1 150cc. Настоящее приключение, честные цены.",
      cta: "Забронировать в WhatsApp",
      ctaAlt: "Смотреть мотоциклы",
    },
    about: {
      kicker: "О нас",
      title: "Чистые мото. Честные цены. Настоящие приключения.",
      body:
        "В Jhossy Motos Rental SJDS мы стремимся предоставлять безопасный, надёжный и доступный сервис аренды мотоциклов — с мотоциклами в отличном состоянии и индивидуальным подходом, который гарантирует удовлетворённость наших клиентов. Наша миссия — обеспечить мобильность местных жителей и туристов, делая каждую поездку удобной, практичной и запоминающейся, с ответственностью, честностью и качеством в каждом сервисе.",
      f1: "Обслуживание на 4 языках",
      f2: "Шлемы включены",
      f3: "Доставка",
      f4: "Кратко- и долгосрочная аренда",
    },
    moto: {
      kicker: "Наш парк",
      title: "Выберите мотоцикл",
      subtitle: "Все Honda, проверены перед каждой арендой.",
      navi: { name: "Honda Navi", engine: "110cc · Автомат", desc: "Идеален для города и ближних пляжей. Лёгкий и простой в управлении даже для новичка." },
      sx2: { name: "Genesis SX1", engine: "150cc · Механика", desc: "Dual-sport для искателей приключений. Для грунтовок, холмов и скрытых пляжей." },
      day: "в день",
      week: "в неделю",
      month: "в месяц",
      book: "Забронировать этот мото",
    },
    rates: { kicker: "Цены", title: "Прозрачные цены. Без сюрпризов.", subtitle: "Цены в USD. Шлемы и доставка включены.", day: "День", week: "Неделя", month: "Месяц" },
    packages: {
      kicker: "Пакеты",
      title: "Экономьте с нашими пакетами",
      subtitle:
        "Отлично для семей, пар и групп друзей. Все мотоциклы — Honda Navi 110cc.",
      bikes: "мото",
      days: "дней",
      price: "Цена пакета",
      book: "Забронировать пакет",
      popular: "Самый популярный",
      includes: {
        title: "Включено",
        bikes: "{{n}} мотоцикла Honda Navi",
        helmets: "Шлем для каждого водителя",
        assist: "Базовая поддержка в течение всей аренды",
      },
      duo: {
        badge: "Пакет Дуо",
        for: "Идеально для пар, друзей или путешественников, желающих исследовать регион свободно по лучшей цене.",
      },
      trio: {
        badge: "Групповой пакет",
        for: "Идеально для компаний друзей или семей — практично, удобно и по отличной цене.",
      },
      quad: {
        badge: "Групповой пакет",
        for: "Идеально для семей, компаний друзей или туристических поездок — комфортно и экономично.",
      },
    },
    gallery: { kicker: "Галерея", title: "Счастливые клиенты", subtitle: "Реальные истории райдеров из Сан-Хуан-дель-Сур." },
    location: { kicker: "Адрес", title: "Найдите нас в центре", body: "Мы в самом центре Сан-Хуан-дель-Сур, в шагах от пляжа. Заходите или пишите в WhatsApp.", hours: "Понедельник – Воскресенье · 8:30 – 17:00", hoursSubtitle: "В Jhossy Motos Rental мы готовы помочь вам найти идеальный мотоцикл для вашего следующего приключения.", directions: "Маршрут" },
    contact: { kicker: "Контакты", title: "Готовы в путь?", body: "Напишите нам в WhatsApp, чтобы забронировать прямо сейчас.", cta: "Написать в WhatsApp", emailCta: "Отправить email", emailTitle: "Напишите нам", emailSubtitle: "Расскажите, что нужно — ответим быстро.", emailPlaceholderName: "Ваше имя", emailPlaceholderMessage: "Даты, желаемый мотоцикл, вопросы…", emailSend: "Открыть почту", emailOr: "или" },
    payments: {
      kicker: "Способы оплаты",
      title: "Быстро, просто и безопасно",
      body:
        "В Jhossy Motos Rental мы хотим сделать ваш опыт удобнее. Мы принимаем оплату через POS — платите дебетовой или кредитной картой быстро, легко и безопасно.",
      tag: "Принимаем POS",
      cards: "Дебет · Кредит",
      footerLabel: "Оплата: POS · Дебет · Кредит",
    },
    footer: { tagline: "Аренда мотоциклов в Сан-Хуан-дель-Сур, Никарагуа.", rights: "Все права защищены." },
    common: { scrollTop: "Наверх", whatsapp: "WhatsApp", callNow: "Позвонить" },
  },
  zh: {
    nav: { home: "首页", motos: "摩托车", packages: "套餐", rates: "价格", gallery: "相册", about: "关于", contact: "联系", book: "预订" },
    hero: {
      tag: "尼加拉瓜 · 圣胡安德尔苏尔",
      title1: "在这里自由骑行：",
      title2: "圣胡安德尔苏尔。",
      subtitle:
        "本田 Navi 110cc 和 Genesis SX1 150cc 摩托车租赁。真实的冒险，公道的价格。",
      cta: "通过 WhatsApp 预订",
      ctaAlt: "查看车型",
    },
    about: {
      kicker: "关于我们",
      title: "干净的车。公道的价。真实的冒险。",
      body:
        "在 Jhossy Motos Rental SJDS，我们致力于提供安全、可靠且实惠的摩托车租赁服务——车辆状况优良，配以贴心的个性化服务，确保客户满意。我们的使命是为本地居民和游客提供便捷出行，让每一次骑行都成为舒适、实用且难忘的体验，以责任、诚信与品质贯穿每一次服务。",
      f1: "多语言服务",
      f2: "含头盔",
      f3: "送车服务",
      f4: "短租与长租",
    },
    moto: {
      kicker: "车队",
      title: "选择您的座驾",
      subtitle: "全部本田品牌，每次出租前均已保养。",
      navi: { name: "本田 Navi", engine: "110cc · 自动挡", desc: "适合市区与附近海滩。轻巧灵活，新手也能轻松驾驭。" },
      sx2: { name: "Genesis SX1", engine: "150cc · 手动挡", desc: "双运动型，适合探险。土路、山丘、隐秘海滩皆可胜任。" },
      day: "每天",
      week: "每周",
      month: "每月",
      book: "预订这辆车",
    },
    rates: { kicker: "价格", title: "价格透明，绝无隐藏。", subtitle: "美元计价，含头盔与送车。", day: "天", week: "周", month: "月" },
    packages: {
      kicker: "套餐",
      title: "选择套餐更划算",
      subtitle: "适合家庭、情侣与朋友团。全部为 Honda Navi 110cc。",
      bikes: "台",
      days: "天",
      price: "套餐价",
      book: "预订套餐",
      popular: "最受欢迎",
      includes: {
        title: "包含",
        bikes: "{{n}} 台 Honda Navi",
        helmets: "每位骑手一顶安全头盔",
        assist: "整个租期内基础协助",
      },
      duo: {
        badge: "双人套餐",
        for: "适合情侣、朋友或想以最佳价格自由探索本地的旅行者。",
      },
      trio: {
        badge: "团体套餐",
        for: "适合朋友团或家庭——实用、舒适、性价比高。",
      },
      quad: {
        badge: "团体套餐",
        for: "适合家庭、朋友团或旅游骑行——舒适又实惠。",
      },
    },
    gallery: { kicker: "相册", title: "满意的客户", subtitle: "来自圣胡安德尔苏尔骑手的真实故事。" },
    location: { kicker: "地点", title: "在市中心找到我们", body: "位于圣胡安德尔苏尔市中心，离海滩只需几步。欢迎光临或 WhatsApp 联系。", hours: "周一至周日 · 上午 8:30 – 下午 5:00", hoursSubtitle: "Jhossy Motos Rental 随时为您服务，帮您找到最适合下次冒险的摩托车。", directions: "路线" },
    contact: { kicker: "联系", title: "准备好上路？", body: "在 WhatsApp 联系我们立即预订。", cta: "WhatsApp 聊天", emailCta: "发送邮件", emailTitle: "给我们发邮件", emailSubtitle: "告诉我们您的需求，我们会快速回复。", emailPlaceholderName: "您的姓名", emailPlaceholderMessage: "日期、想要的车型、疑问…", emailSend: "打开邮件", emailOr: "或" },
    payments: {
      kicker: "付款方式",
      title: "快速、便捷、安全付款",
      body:
        "在 Jhossy Motos Rental，我们希望让您的体验更加便捷。我们接受 POS 付款，您可以使用借记卡或信用卡快速、便捷、安全地付款。",
      tag: "接受 POS 付款",
      cards: "借记卡 · 信用卡",
      footerLabel: "付款方式：POS · 借记 · 信用",
    },
    footer: { tagline: "尼加拉瓜圣胡安德尔苏尔摩托车租赁。", rights: "版权所有。" },
    common: { scrollTop: "顶部", whatsapp: "WhatsApp", callNow: "拨打" },
  },
  pt: {
    nav: { home: "Início", motos: "Motos", packages: "Pacotes", rates: "Preços", gallery: "Galeria", about: "Sobre", contact: "Contato", book: "Reservar" },
    hero: {
      tag: "San Juan del Sur, Nicarágua",
      title1: "Ande livre em",
      title2: "San Juan del Sur.",
      subtitle:
        "Aluguel de motos Honda Navi 110cc e Genesis SX1 150cc. Aventura autêntica, preços honestos.",
      cta: "Reservar pelo WhatsApp",
      ctaAlt: "Ver motos",
    },
    about: {
      kicker: "Sobre nós",
      title: "Motos limpas. Preços justos. Aventuras reais.",
      body:
        "Na Jhossy Motos Rental SJDS nos dedicamos a oferecer um serviço de aluguel de motos seguro, confiável e acessível — com motos em excelentes condições e um atendimento personalizado que garante a satisfação dos nossos clientes. Nosso compromisso é facilitar a mobilidade de moradores e turistas, tornando cada passeio uma experiência confortável, prática e memorável, com responsabilidade, honestidade e qualidade em cada serviço.",
      f1: "Atendimento multilíngue",
      f2: "Capacetes inclusos",
      f3: "Serviço de entrega",
      f4: "Aluguel curto e longo prazo",
    },
    moto: {
      kicker: "Nossa frota",
      title: "Escolha sua moto",
      subtitle: "Todas Honda, revisadas antes de cada aluguel.",
      navi: { name: "Honda Navi", engine: "110cc · Automática", desc: "Perfeita para a cidade e praias próximas. Leve, ágil, fácil mesmo para iniciantes." },
      sx2: { name: "Genesis SX1", engine: "150cc · Manual", desc: "Dual-sport para exploradores. Ideal para estradas de terra, morros e praias escondidas." },
      day: "por dia",
      week: "por semana",
      month: "por mês",
      book: "Reservar esta moto",
    },
    rates: { kicker: "Preços", title: "Preços claros. Sem surpresas.", subtitle: "Preços em USD. Capacetes e entrega inclusos.", day: "Dia", week: "Semana", month: "Mês" },
    packages: {
      kicker: "Pacotes",
      title: "Economize com nossos pacotes",
      subtitle:
        "Perfeito para famílias, casais e grupos de amigos. Todas as motos são Honda Navi 110cc.",
      bikes: "motos",
      days: "dias",
      price: "Preço do pacote",
      book: "Reservar pacote",
      popular: "Mais popular",
      includes: {
        title: "Inclui",
        bikes: "{{n}} motos Honda Navi",
        helmets: "Capacete de segurança para cada condutor",
        assist: "Assistência básica durante todo o período de aluguel",
      },
      duo: {
        badge: "Pacote Duo",
        for: "Ideal para casais, amigos ou viajantes que querem explorar a região com liberdade e ao melhor preço.",
      },
      trio: {
        badge: "Pacote Grupo",
        for: "Ideal para grupos de amigos ou famílias — prático, confortável e ótimo custo-benefício.",
      },
      quad: {
        badge: "Pacote Grupo",
        for: "Ideal para famílias, grupos de amigos ou passeios turísticos — confortável e econômico.",
      },
    },
    gallery: { kicker: "Galeria", title: "Clientes felizes", subtitle: "Histórias reais de riders em San Juan del Sur." },
    location: { kicker: "Endereço", title: "Encontre-nos no centro", body: "Estamos no coração de San Juan del Sur, a passos da praia. Venha nos visitar ou fale pelo WhatsApp.", hours: "Segunda a domingo · 8h30 – 17h00", hoursSubtitle: "Na Jhossy Motos Rental estamos prontos para ajudar você a encontrar a moto ideal para sua próxima aventura.", directions: "Como chegar" },
    contact: { kicker: "Contato", title: "Pronto para rodar?", body: "Fale conosco no WhatsApp para reservar agora.", cta: "Falar no WhatsApp", emailCta: "Enviar e-mail", emailTitle: "Envie um e-mail", emailSubtitle: "Diga o que precisa — respondemos rápido.", emailPlaceholderName: "Seu nome", emailPlaceholderMessage: "Datas, moto desejada, dúvidas…", emailSend: "Abrir e-mail", emailOr: "ou" },
    payments: {
      kicker: "Formas de pagamento",
      title: "Pague rápido, fácil e seguro",
      body:
        "Na Jhossy Motos Rental queremos tornar sua experiência mais confortável. Aceitamos pagamentos com POS, para você pagar com seu cartão de débito ou crédito de forma rápida, fácil e segura.",
      tag: "Aceitamos POS",
      cards: "Débito · Crédito",
      footerLabel: "Pagamento: POS · Débito · Crédito",
    },
    footer: { tagline: "Aluguel de motos em San Juan del Sur, Nicarágua.", rights: "Todos os direitos reservados." },
    common: { scrollTop: "Topo", whatsapp: "WhatsApp", callNow: "Ligar" },
  },
};

const resources = Object.fromEntries(
  Object.entries(t).map(([k, v]) => [k, { translation: v }])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["es", "en", "fr", "de", "ru", "zh", "pt"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export const LANGS = [
  { code: "es", label: "Español", flag: "🇳🇮" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "pt", label: "Português", flag: "🇧🇷" },
];

export default i18n;
